export default {
  serviceDTO: {},
  description: "",
};
